import type { ReactNode } from 'react';

/** Product theme wrapper classes (for layouts/stories that set context on an ancestor). */
export const externalLinkThemeClasses = [
  'color_topic',
  'color_analysis',
  'color_datalab',
  'color_vantage',
  'color_insights',
] as const;

export type ExternalLinkThemeClass = (typeof externalLinkThemeClasses)[number];

export type ExternalLinkVariant = 'link' | 'icon';

export type ExternalLinkProps = {
  /**
   * `link` (default): theme link color and underline for text links.
   * `icon`: minimal anchor styling for icon-only help links; appearance comes from children.
   */
  variant?: ExternalLinkVariant;
  /**
   * Optional content before the anchor, shown on the same line as the link (with spacing via flex gap).
   */
  label?: ReactNode;
  /** Destination URL opened in a new tab. */
  href: string;
  /** Content rendered inside the anchor (text or elements). */
  children: ReactNode;
  /** Additional CSS classes on the anchor element. */
  extraClassNames?: string;
  /** Optional `data-testid` on the anchor. */
  testId?: string;
};
